module.exports = "<div>\n  <ng-content></ng-content>\n</div>"